<template>
  <div id="app">
    <!-- <link href="/../favicon.png" rel="shortcut icon" type="image/x-icon" /> -->
    <transition name="component-fade" mode="out-in">
    <router-view />
    </transition>
  </div>
</template>

<script>
import { routes } from "./routes";

export default {
  name: 'App',
  components: {
  },
  data() {
    return {
      routes
    };
  }
}
</script>

<style>

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
body {
  background-image: url('./assets/background.jpg');
  background-attachment: fixed;
}

.semitransp {
     background:  rgba(0, 0, 0, 0.8) ;
    /* background: none; */
}

.espacador {
  padding-bottom: 1.0rem;
}
.expl_fig{
  /* font-family: 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif; */
  color: white;
  font-size: 1.2rem;
  padding-left: 15vw;
  padding-right: 15vw;
}
.espacada{
  padding-left: 5vw;
  padding-right: 5vw;
}
.imagens{
  padding-bottom: 0.8rem;
}

.component-fade-enter-active,
.component-fade-leave-active {
  transition: opacity 0.5s ease;
}
.component-fade-enter,
.component-fade-leave-to {
  opacity: 0;
}
</style>
